import Customize from './Customize'
import Watermark from './Watermark'

export default {
  Customize,
  Watermark
}
